import THREEWorld from './THREEWorld'
import utils from './WorldUtils'
import $ from 'jquery'
import RooftopController from './RooftopController'
import pinch from 'touch-pinch'
// import Cursor from './Cursor'
// import {TweenLite} from 'gsap'
const THREE = window.THREE

let App = function (elementId, $bus, $router, chapters) {
  this.init(elementId, $bus, $router, chapters)
}

App.prototype = {
  CURSOR_MODE_ZOOMIN: 0,
  CURSOR_MODE_PANZOOMIN: 1,
  CURSOR_MODE_ZOOMINOUT: 2,
  cursorMode: this.CURSOR_MODE_ZOOMIN,
  cursorDirection: 'zoomIn',
  init (elementId, $bus, $router, chapters) {
    this.container = document.getElementById(elementId)
    this.$bus = $bus
    this.router = $router
    this.currentPositionIndex = 0
    this.routes = utils.indexRoutes($router.options.routes)
    this.threeWorld = new THREEWorld(this.container, $bus)
    this.addEventListeners()
    this.initLoadingManager()
    this.loadCustomProperties()
      .then(() => this.loadChapters(chapters))
      .then(() => this.loadRooftops(chapters))
      .then(this.onLoaded.bind(this))
  },
  addEventListeners () {
    this.$bus.$on('zone-clicked', this.onZoneClicked.bind(this))
    this.$bus.$on('zone-touched', this.onZoneTouched.bind(this))
    this.$bus.$on('click', this.onContainerClicked.bind(this))
    this.$bus.$on('touchend', this.onContainerTouched.bind(this))
    this.$bus.$on('zone-hovered', this.onZoneHovered.bind(this))
    this.$bus.$on('no-zone-hovered', this.onNoZoneHovered.bind(this))
    this.$bus.$on('mouse-move', this.onMouseMove.bind(this))
    this.$bus.$on('USER_IS_TOUCHING', this.onUserTouch.bind(this))
  },
  onUserTouch () {
    if (!this.userIsTouching) {
      this.threeWorld.scene.remove(this.chapters.collage.scene)
      this.userIsTouching = true
      pinch(window).on('change', this.onPinch.bind(this))
      document.addEventListener('gesturestart', function (e) {
        e.preventDefault()
      })
    }
  },
  getCursorDirection (y) {
    if (y < -0.5) {
      return 'back'
    }
    if (this.shownChapter.zones[this.currentPositionIndex].nextZone) {
      return 'next'
    }
    return 'back to start'
  },
  onMouseMove (e) {
    let cursorDirection = this.cursorDirection
    if (this.cursorMode === this.CURSOR_MODE_ZOOMINOUT) {
      cursorDirection = this.getCursorDirection(e.mouse.y)
    }
    this.setCursor(cursorDirection)
  },
  setCursor (direction) {
    this.cursorDirection = direction
    this.$bus.$emit('set-cursor', direction)
  },
  setCursorModeByZoneIndex (index) {
    switch (utils.cleanChapterIndex(index)) {
      case 0:
      case 1:
      case 'where':
      case 'double-dutch':
      case 'who':
      case 'what':
      case 'why':
      case 'when':
      case 'extremes':
      case 'the-end':
        this.cursorMode = this.CURSOR_MODE_ZOOMIN
        this.$bus.$emit('invert-cursor', false)
        $('#app').addClass('rooftop')
        break
      case 'not implemented':
        this.cursorMode = this.CURSOR_MODE_PANZOOMIN
        this.$bus.$emit('invert-cursor', false)
        $('#app').addClass('rooftop')
        break
      default:
        this.cursorMode = this.CURSOR_MODE_ZOOMINOUT
        this.$bus.$emit('invert-cursor', true)
        $('#app').removeClass('rooftop')
    }
  },
  onPinch (dist, prev) {
    if (this.currentPositionIndex === 0) { // disable pinch on rooftop
      return
    }
    let distanceDelta = dist - prev
    let to = new THREE.Vector3()
    to.x = this.threeWorld.camera.position.x
    to.y = this.threeWorld.camera.position.y
    to.z = this.threeWorld.camera.position.z - distanceDelta
    if (this.shownChapter.minZ) {
      to.z = Math.max(this.shownChapter.minZ, to.z)
    }
    this.threeWorld.camera.position.copy(to)
  },
  onNoZoneHovered () {
    // this.cursor.setCursorDirection('zoomIn')
    this.setCursor('zoomIn')
    this.noZoneHovered = true
  },
  onZoneHovered (zone) {
    this.setCursorForZone(zone)
    this.lastZoneHovered = zone
    this.noZoneHovered = false
  },
  setCursorForZone (zoneIndex) {
    if (this.currentPositionIndex === zoneIndex) {
      this.setCursor(zoneIndex)
    } else {
      this.setCursor('zoomIn')
    }
    this.setCursorModeByZoneIndex(zoneIndex)
  },
  setBackgroundForZone (zoneIndex) {
    this.threeWorld.setSceneBackgroundByZoneIndex(zoneIndex)
  },
  onContainerClicked (e, moved) {
    if (this.cursorMode === this.CURSOR_MODE_ZOOMINOUT) {
      this.zoomInOut(this.cursorDirection)
    }
  },
  zoomInOut (direction) {
    switch (direction) {
      case 'next':
        this.gotoNextZone()
        break
      case 'back':
        this.gotoPreviousZone()
        break
      case 'back to start':
        this.gotoRoute(0)
        break
    }
  },
  onContainerTouched (e) {
    if (this.cursorMode === this.CURSOR_MODE_ZOOMINOUT) {
      if (!e.moved) {
        const y = -(e.touchEvent.changedTouches[0].clientY / window.innerHeight) * 2 + 1
        const direction = this.getCursorDirection(y)
        this.zoomInOut(direction)
      }
    } else if (this.noZoneHovered) {
      this.gotoPosition(this.lastZoneHovered)
    }
  },
  gotoNextZone () {
    this.gotoRoute(this.shownChapter.zones[this.currentPositionIndex].nextZone)
  },
  gotoPreviousZone () {
    this.goBack()
  },
  goBack () {
    window.history.back()
  },
  onZoneClicked (zone, moved) {
    if (this.currentPositionIndex === zone.object.zoneIndex) {
      if (moved) {
        this.gotoPosition(zone.object.zoneIndex)
      } else {
        this.gotoRoute(zone.object.nextZone)
      }
    } else {
      this.gotoRoute(zone.object.zoneIndex)
    }
  },
  onZoneTouched (zone, moved) {
    if (this.currentPositionIndex === zone.object.zoneIndex) {
      if (moved) {
        this.gotoPosition(zone.object.zoneIndex)
      } else {
        this.gotoRoute(zone.object.nextZone)
      }
    } else {
      this.gotoRoute(zone.object.nextZone)
    }
  },
  loadRooftops (chapters) {
    Object.assign(this.chapters, {
      0: new RooftopController(
        'modelIndex',
        {},
        this.$bus,
        'model',
        null,
        2,
        -50
      ),
      collage: new RooftopController(
        'collageIndex',
        utils.parseIndexChapter(chapters),
        this.$bus,
        'zoom',
        null,
        1
      )
    })
    return Promise.all([
      this.chapters[0].load(this.customProperties, this.loadingManager),
      this.chapters.collage.load(this.customProperties, this.loadingManager)
    ])
  },
  loadChapters (chapters) {
    this.chapters = utils.parseChapters(chapters, this.$bus)
    return Promise.all(Object.keys(this.chapters).map(key => {
      let chapter = this.chapters[key]
      return chapter.load(this.customProperties, this.loadingManager)
    }))
  },
  loadCustomProperties () {
    return new Promise((resolve, reject) => {
      $.ajax('./static/data/model.json', {
        success: data => {
          this.customProperties = data
          resolve()
        },
        error: reject
      })
    })
  },
  initLoadingManager () {
    this.loadingManager = new THREE.LoadingManager()
    this.loadingManager.onProgress = this.onLoadingManagerProgress.bind(this)
    this.loadingManager.onLoad = this.onManagerLoaded.bind(this)
    this.loadingManager.onStart = this.onManagerStart.bind(this)
  },
  onManagerStart (url, itemsLoaded, itemsTotal) {
    this.$bus.$emit('loading-manager-start', {url, itemsLoaded, itemsTotal})
  },
  onLoadingManagerProgress (item, loaded, total) {
    this.$bus.$emit('loading-manager-progress', {loaded, total})
  },
  onManagerLoaded () {
    this.$bus.$emit('world-loaded')
  },
  onLoaded () {
    this.loaded = true
    this.gotoQueuedPosition()
  },
  gotoRoute (index) {
    let slug = this.routes[utils.cleanChapterIndex(index)].path
    this.router.push(slug)
  },
  gotoQueuedPosition () {
    if (typeof this.queuedPositionIndex !== 'undefined') {
      this.gotoPosition(this.queuedPositionIndex)
    }
  },
  getChapterIndex (index) {
    let chapterNames = ['where', 'double-dutch', 'who', 'what', 'why', 'when', 'extremes', 'the-end']
    if (chapterNames.indexOf(index) !== -1) return 'collage'
    return index
  },
  removeChapterScene (chapter) {
    if (chapter) {
      chapter.removeScene()
    }
  },
  fadeOutChapter (chapter) {
    if (chapter) {
      return chapter.fadeOutScene()
    }
    return Promise.resolve()
  },
  gotoPosition (index) {
    if (this.loaded) {
      let chapterIndex
      if (index.toString().indexOf('.') !== -1) {
        chapterIndex = index.charAt(0)
      } else {
        chapterIndex = index
      }

      if (this.shownChapter !== this.chapters[this.getChapterIndex(chapterIndex)]) {
        const direction =
          (this.shownChapter ? this.shownChapter.getZIndex() : 0) -
          this.chapters[this.getChapterIndex(chapterIndex)].getZIndex()
        const fromChapter = this.shownChapter
        const toChapter = this.chapters[this.getChapterIndex(chapterIndex)]
        if (this.shownChapter) {
          this.shownChapter.disable()
        }
        if (direction < 0) {
          toChapter.addToAndfadeIn(this.threeWorld)
            .then(() => this.removeChapterScene(fromChapter))
            .then(() => toChapter.enable())
        } else {
          toChapter.addTo(this.threeWorld)
          this.fadeOutChapter(fromChapter)
            .then(() => toChapter.enable())
        }
        this.shownChapter = this.chapters[this.getChapterIndex(chapterIndex)]
      }
      if (window.videos[this.currentPositionIndex]) {
        window.videos[this.currentPositionIndex].pause()
      }
      if (window.videos[index]) {
        window.videos[index].play()
      }
      let toPosition =
        this.shownChapter ? this.shownChapter.toPositions[index] : this.chapter
      this.currentPositionIndex = index
      this.setCursorForZone(index)
      this.threeWorld.gotoPosition(toPosition, false, this.currentPositionIndex).then(() => {
      })
      // start video for toPosition. also see if video should be started.
      this.setBackgroundForZone(index)
      this.shownChapter.showTextsForZone(index, this.threeWorld.cssScene)
      this.threeWorld.positionFactor = this.shownChapter.positionFactor
    } else {
      this.queuedPositionIndex = index
    }
  }
}

export default App



// WEBPACK FOOTER //
// ./src/world/App.js